class License {
  constructor(api) {
    this.api = api;
  }

  getLicense(onSuccess, onError) {
    return this.api.http_fibercloud
      .get("v1/configurations")
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }

  edit(data, onSuccess, onError) {
    return this.api.http_fibercloud
      .put("v1/configurations/", data)
      .then(resp => {
        onSuccess(resp);
      })
      .catch(error => {
        onError(error);
      });
  }
}

export default License;



// WEBPACK FOOTER //
// ./src/api/license.js